import {Button} from "antd";
import {Icon, Typography} from "@bezlimit/bezlimit-ui";
import {useNavigate} from "react-router-dom";
import {observer} from "mobx-react";
import {useEffect, useState} from "react";
import _ from "lodash";

interface INotifications {
    noticeCount: number;
}

export default observer(function Notifications({noticeCount}: INotifications) {
    const navigate = useNavigate();
    const [total, setTotal] = useState(noticeCount);

    useEffect(() => {
        setTimeout(() => {
            setTotal(noticeCount);
        }, 100);
    }, [noticeCount]);

    const click = () => {
        navigate("/notifications");
        setTotal(0);
    };

    useEffect(() => {
        if (_.gt(total, 0)) {
            document.querySelector(".bl-notifications")?.classList.add("bl-news__move-shake");
            setTimeout(() => {
                document
                    .querySelector(".bl-notifications")
                    ?.classList.remove("bl-news__move-shake");
            }, 3000);
        }
    }, [noticeCount, total]);

    return (
        <Typography as="div" className="bl-notifications">
            <Button
                className="btn-default"
                onClick={() => {
                    click();
                }}
                icon={<Icon className="bl-news__icon" name="notifications" />}
            />
            {_.gt(total, 0) && (
                <Typography className="bl-news__red-circle" as={"div"}>
                    {noticeCount}
                </Typography>
            )}
        </Typography>
    );
});
